<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'production-qualityIssues',
  components: {
    PageTable,
  },
}
</script>
